import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { useEffect, useState } from "react";
import {
  fetchSellerOrders,
  updateOrderStatus,
} from "../../../State/seller/sellerOrderSlice";
import { OrderStatus } from "./../../../types/orderTypes";
import { Button, Menu, MenuItem, Pagination } from "@mui/material";
import { fetchProductById, fetchProductDetailById } from "../../../State/customer/ProductSlice";

const orderStatusColor = [
  { color: "#FFA500", label: "PENDING" },
  { color: "#F5BCBA", label: "PLACED" },
  { color: "#F5BCBA", label: "CONFIRMED" },
  { color: "#1E90FF", label: "SHIPPED" },
  { color: "#32CD32", label: "DELIVERED" },
  { color: "#FF0000", label: "CANCELLED" },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
type AnchorState = {
  anchorEl: HTMLElement | null;
  orderId?: number;
};

export default function OrdersTable() {
  const dispatch = useAppDispatch();
  const [size, setSize] = useState(4);
  
  const [page, setPage] = useState(0);
  const productByIds=useAppSelector(store=>store.product.entities)
  const detailByIds=useAppSelector(store=>store.product.entitiesDetails)
  const [anchorEl, setAnchorEl] = React.useState<AnchorState>({
    anchorEl: null,
  });
  const open = Boolean(anchorEl.anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    orderId: number
  ) => {
    setAnchorEl({
      anchorEl: event.currentTarget,
      orderId: orderId,
    });
  };
  const handleClose = () => {
    setAnchorEl({
      anchorEl: null,
    });
  };

  const handleUpdateOrderStatus = async(
    orderId: number | null | undefined,
    orderStatus: OrderStatus
  ) => {
    setAnchorEl({
      anchorEl: null,
    });
    if (orderId !== null && orderId !== undefined) {
    await  dispatch(updateOrderStatus({ orderId, orderStatus }));
    
    }
  };
  
  const { sellerOrders } = useAppSelector((store) => store);
  useEffect(() => {
    dispatch(fetchSellerOrders({ page, size }));
  }, [dispatch, page, size]);
  useEffect(() => { 
    if (!sellerOrders.orders?.length) return;
    sellerOrders.orders.forEach((item)=>{
      const productIds =Array.from(new Set(item.items.map((i)=>i.productId)))
      const detailIds = Array.from(new Set(item.items.map((i)=>i.productDetailId)))
     productIds.forEach((id)=>dispatch(fetchProductById(id)))
     detailIds.forEach((id)=>dispatch(fetchProductDetailById(id)))
  })
   },[dispatch,sellerOrders.orders])
  const handleChangeColor = (status: OrderStatus) => {
    const match = orderStatusColor.find((item) => item.label === status);
    return match ? match.color : "#000"; // Default color if no match
  };

  
  return sellerOrders.orders && sellerOrders.orders.length > 0 ? (
    
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Order Id</StyledTableCell>
            <StyledTableCell sx={{ textAlign: "left" }}>
              Products(name,color,size,quantity)
            </StyledTableCell>
            <StyledTableCell sx={{ textAlign: "left" }}>
              Images
            </StyledTableCell>
           
            <StyledTableCell sx={{ textAlign: "left" }} align="right">
              Shipping Address
            </StyledTableCell>
            <StyledTableCell sx={{ textAlign: "left" }} align="right">
              Order Status
            </StyledTableCell>
            <StyledTableCell sx={{ textAlign: "left" }} align="right">
              Update
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sellerOrders.orders.map((order) =>{
            const isFinal =
            order.orderStatus === OrderStatus.CANCELLED ||
            order.orderStatus === OrderStatus.DELIVERED;
            return(
            
            <StyledTableRow key={order.id}>
              <StyledTableCell component="th" scope="row">
                {order.id}
              </StyledTableCell>
              <StyledTableCell>
                <div className="flex flex-col text-left gap-1 flex-wrap lg:space-y-3 xl:space-y-0 xl:space-x-3">
                  {order.items.map((item,index) =>{
                    const prod = productByIds[item.productId]
                    const det = detailByIds[item.productDetailId]
                    return (
                    <div key={item.id} style={{margin:0}} className=" gap-5 ">
            
                     
                      <div className="flex py-2">
                        <h1> {prod?.title} - {det?.color} - {det?.size} - {item.quantity}</h1>
                        {order.items.length>1&&index<order.items.length-1&&","}
                       
                      </div>
                    </div>
                  )})}
                </div>
              </StyledTableCell> 
              <StyledTableCell>
              <div className="flex gap-1 flex-wrap lg:space-y-3 xl:space-y-0 xl:space-x-3">
                  {order.items.map((item,index) =>{
                    const prod = productByIds[item.productId]
                    const det = detailByIds[item.productDetailId]
                    return (
                    <div key={item.id} style={{margin:0}} className=" gap-5  ">
                      {prod?.images&& (<img
                        className="w-20 rounded-md   "
                        src={prod.images[0]}
                        alt=""
                      />)}
                      
                    </div>
                  )})}
                </div>
              </StyledTableCell>
             
              <StyledTableCell>
                <div className="flex flex-col p-2   gap-y-2">
                  <h1>{order.shippingAddress.streetName}</h1>
                  <h1>
                    {order.shippingAddress.postalCode} -{" "}
                    {order.shippingAddress.city}
                  </h1>
                  <h1>{order.shippingAddress.country}</h1>
                  <h1>
                    <strong>Mobile: </strong> {order.shippingAddress.mobile}
                  </h1>
                </div>
              </StyledTableCell>
              <StyledTableCell sx={{ textAlign: "left" }} align="right">
                <span
                  style={{
                    borderColor: handleChangeColor(order.orderStatus),
                    color: handleChangeColor(order.orderStatus),
                  }}
                  className={`px-5 py-2 border rounded-full `}
                >
                  {order.orderStatus}
                </span>
              </StyledTableCell>
                  
              <StyledTableCell sx={{ textAlign: "left" }} align="right">
                <Button
                  disabled={isFinal}
                  key={order.id}
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={(event) => {
                    handleClick(event, order.id);
                  }}
                >
                  STATUS
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl.anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {orderStatusColor.map((item, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => {
                        handleUpdateOrderStatus(
                          anchorEl.orderId,
                          item.label as OrderStatus
                        );
                      }}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </Menu>
              </StyledTableCell>
            </StyledTableRow>
          )})}
        </TableBody>
      </Table>
      <div className="flex justify-center py-10 ">
        <Pagination
          page={page + 1} //Convert 0-based page to 1-based UI
          onChange={(e, value) => setPage(value - 1)} // Convert back to API page so 1 in UI meant 0 in API 2 in UI meant 1 in API API always start from 0
          count={sellerOrders.totalPages}
          color="primary"
          shape="rounded"
        />
      </div>
    </TableContainer>
  ) : (
    <div>
      <h1 className="text-xl">You have no orders here</h1>
    </div>
  );
}
